import { blocks as themeBlockConfig } from '../../../../../../theme-config'

window.addEventListener('load', function () {
    if (typeof google === "undefined") {
        return null;
    }

    const mapElements = document.querySelectorAll('.cite-wordpress-theme-map');

    for (var i = 0; i < mapElements.length; i++) {
        const element = mapElements[i];

        const lat = parseFloat(element.dataset.lat);
        const lng = parseFloat(element.dataset.lng);
        const zoom = parseFloat(element.dataset.zoom);

        const location = {
            lat: lat,
            lng: lng
        }

        const mapOptions = {
            zoom: zoom,
            center: location,
            ...themeBlockConfig.map.options
        }

        const map = new google.maps.Map(element, mapOptions);

        const icon = {
            url: themeBlockConfig.map.markerImage.url,
            scaledSize: new google.maps.Size(themeBlockConfig.map.markerImage.size.width, themeBlockConfig.map.markerImage.size.height),
            anchor: new google.maps.Point(themeBlockConfig.map.markerImage.anchor.x, themeBlockConfig.map.markerImage.anchor.y)
        }

        const marker = new google.maps.Marker({
            position: location,
            map: map,
            icon: icon,
        });
    }
});
